<div class="titulo-receber-table">
    <table class="table table-striped table-hover table-bordered" [id]="idDataTable">
        <thead>
            <tr>
                <th class="col-options"></th>
                <th class="col-numero">Número</th>
                <th class="col-situacao text-center">Situação</th>
                <th class="col-pessoa">Cliente</th>
                <th class="col-emissao text-center">Emissão</th>
                <th class="col-vencimento text-center">Vencimento</th>
                <th class="col-pagamento text-center">Pagamento</th>
                <th class="col-dias-em-atraso text-right">Dias Em Atraso</th>
                <th class="col-valor text-right">Valor</th>
                <th class="col-valor-pago text-right">Valor Pago</th>
                <th class="col-valor-renegociado text-right">Valor Renegociado</th>
                <!-- <th class="col-valor-juros text-right">Juros</th> -->
                <th class="col-valor-saldo text-right">Saldo</th>
                <th class="col-valor-adimplencia text-right">Adimplência R$</th>
                <th class="col-perc-adimplencia text-right">Adimplência %</th>
                <th class="col-representante">Representante</th>
                <th class="col-data-atualizacao-financeira text-center">Atualização Financeira</th>
                <th class="col-anotacao-financeira">Anotação Financeira</th>
            </tr>
        </thead>
        <tfoot>
            <tr>
                <td class="col-options">
                    
                </td>
                <td class="col-numero"></td>
                <td class="col-situacao text-center"></td>
                <td class="col-pessoa">
                    {{(total?.quantidadeTitulosReceber ? total?.quantidadeTitulosReceber : 0) | decimalFormat: 1:0:0}} títulos
                </td>
                <td class="col-emissao text-center"></td>
                <td class="col-vencimento text-center"></td>
                <td class="col-pagamento text-center"></td>
                <td class="col-dias-em-atraso text-right"></td>

                <td class="col-valor text-right">
                    {{(total?.valorTotal ? total?.valorTotal : 0) | currencyFormat: 1:2:2}}
                </td>
                <td class="col-valor-pago text-right">
                    {{(total?.valorTotalPago ? total?.valorTotalPago : 0) | currencyFormat: 1:2:2}}
                </td>
                <td class="col-valor-renegociado text-right">
                    {{(total?.valorTotalRenegociado ? total?.valorTotalRenegociado : 0) | currencyFormat: 1:2:2}}
                </td> 
                <!-- <td class="col-valor-juros text-right"></td> -->
                <td class="col-valor-saldo text-right">
                    {{(total?.valorTotalSaldo ? total?.valorTotalSaldo : 0) | currencyFormat: 1:2:2}}
                </td>                
                <td class="col-valor-adimplencia text-right">
                    {{(total?.valorTotalAdimplencia ? total?.valorTotalAdimplencia : 0) | currencyFormat: 1:2:2}}
                </td> 
                <td class="col-perc-adimplencia text-right">
                    {{(total?.percAdimplencia ? total?.percAdimplencia : 0) | decimalFormat: 1:2:2}}%
                </td>                                                                                                                                   
                <td class="col-representante"></td>  
                <td class="col-data-atualizacao-financeira text-center"></td>  
                <td class="col-anotacao-financeira"></td>                                                                                    
            </tr>
        </tfoot>
    </table>         
</div>